import { render } from "./all-banks.vue?vue&type=template&id=0d7d208d&scoped=true"
import script from "./all-banks.vue?vue&type=script&lang=js"
export * from "./all-banks.vue?vue&type=script&lang=js"

import "./all-banks.vue?vue&type=style&index=0&id=0d7d208d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7d208d"]])

export default __exports__